import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { numberFormat } from 'helper';
import UpdateModal from '../component/UpdateModal';
import * as actions from '../../../../action';
import * as c from '../../../../constant';

function LandMarketValueContainer({
  getLandMarketValueList,
  getHistoryMarketValueList,
  landMarketValueList,
  applicationInfo,
  removeLandMarketValue,
  type,
  landAppraisalId,
  ordinanceRevisionId
}) {
  const setModal = useContext(ModalContext);

  const handleUpdateLandMarketValue = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data.attributes}
          id={data.id}
          applicationId={id}
          landMarketValueInfo={data}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Market Value',
      modalSize: 'modal-md',
    });
  };

  const handleremoveLandMarketValue = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this Market Value?',
      () => {
        removeLandMarketValue(id, landAppraisalId, data.id, () => {
          getLandMarketValueList(id, landAppraisalId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    if (_.isEmpty(applicationInfo.id)) return;
    if (type === 'history')
      getHistoryMarketValueList(applicationInfo.id, landAppraisalId);
    else getLandMarketValueList(applicationInfo.id, landAppraisalId);
  }, []);

  return (
    <table
      width="100%"
      className="transaction-table table table-sm table-bordered"
    >
      <thead>
        <tr>
          <th className="border-bottom border-right">Adjustment Factors</th>
          <th className="border-bottom border-right">% Adjustment</th>
          <th className="border-bottom border-right">Value Adjustment</th>
          {type !== 'history' &&
            _.get(applicationInfo, 'attributes.status') !== 'POSTED' &&
            ['CANCELLED'].indexOf(
              _.get(applicationInfo, 'attributes.status')
            ) <= -1 && (
              <th className="text-center border-bottom border-right">
                Actions
              </th>
            )}
        </tr>
      </thead>
      <tbody>
        {landMarketValueList && landMarketValueList.length <= 0 && (
          <tr className="text-center">
            <td colSpan="4">No data</td>
          </tr>
        )}
        {landMarketValueList &&
          landMarketValueList.map((item) => (
            <tr key={item.id}>
              <td className="border-bottom border-right">
                {_.get(item, 'attributes.adjustment_factor')}
              </td>
              <td className="border-bottom border-right">
                {_.get(item, 'attributes.percentage_adjustment')}
              </td>
              <td className="border-bottom border-right">
                {numberFormat(_.get(item, 'attributes.value_adjustment'), 2)}
              </td>
              {type !== 'history' &&
                _.get(applicationInfo, 'attributes.status') !== 'POSTED' &&
                ['CANCELLED'].indexOf(
                  _.get(applicationInfo, 'attributes.status')
                ) <= -1 && (
                  <td className="text-center border-bottom border-right">
                    <button
                      onClick={handleUpdateLandMarketValue(
                        applicationInfo.id,
                        item
                      )}
                      type="button"
                      className="btn-blank"
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleremoveLandMarketValue(
                        applicationInfo.id,
                        item
                      )}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                )}
            </tr>
          ))}
        <tr>
          <td />
          <td>
            {' '}
            <span className="transaction-text font-weight-bold">Total:</span>
          </td>
          <td>
            {numberFormat(
              landMarketValueList.reduce(
                (sum, num) => sum + num.attributes.value_adjustment,
                0
              ),
              2
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

LandMarketValueContainer.defaultProps = {
  type: '',
  landAppraisalId: '',
  applicationInfo: {},
};

LandMarketValueContainer.propTypes = {
  getLandMarketValueList: PropTypes.instanceOf(Function).isRequired,
  getHistoryMarketValueList: PropTypes.instanceOf(Function).isRequired,
  landMarketValueList: PropTypes.instanceOf(Array).isRequired,
  applicationInfo: PropTypes.instanceOf(Object),
  removeLandMarketValue: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  landAppraisalId: PropTypes.string,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  landMarketValueList: _.get(api, `${c.GET_LAND_MARKET_VALUE}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandMarketValueContainer);
